import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M960,15 L693.226667,257.026667 L333.44,243.053333 L284.693333,599.96 L0,820.546667 L192,1125.18667 L115.733333,1477.18667 L458.666667,1587.16 L626.56,1905.77333 L960,1769.56 L1293.44,1905.77333 L1461.33333,1587.16 L1804.26667,1477.18667 L1728,1125.18667 L1920,820.546667 L1635.30667,599.96 L1586.56,243.053333 L1226.66667,257.026667 L960,15 Z M1312.74667,631.426667 L1460.58667,785.24 L860.586667,1362.52 L457.813333,959.746667 L608.64,808.92 L863.573333,1063.74667 L1312.74667,631.426667 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconCertifiedSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconCertifiedSolid, _Component);

  var _super = _createSuper(IconCertifiedSolid);

  function IconCertifiedSolid() {
    _classCallCheck(this, IconCertifiedSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconCertifiedSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconCertified",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconCertifiedSolid.displayName = "IconCertifiedSolid";
  return IconCertifiedSolid;
}(Component);

IconCertifiedSolid.glyphName = 'certified';
IconCertifiedSolid.variant = 'Solid';
IconCertifiedSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconCertifiedSolid;
export { IconCertifiedSolid };